import { RigidRegistration } from '~/domain/patient/rigidRegistration';
import { DoseDistribution } from './dose/DoseDistribution';
import { ImageObject } from './image/ImageObject';
import { StructureSetObject } from './structure/StructureSetObject';

/**
 * {@link Environment} is a storage class, storing the state of the objects that are currently being viewed.\
 * Environment also stores the common viewing parameters shared between the views.
 */
export class EnvironmentObjects {
    // Primary image being displayed in the viewer. This defines the basic coordinate system (Frame of Reference) for the viewer.
    public primaryImage: ImageObject | undefined;

    // Secondary image being displayed in the viewer.
    // The secondary image must include a transformation
    // to the frame of reference of the primary image to be rendered correctly.
    public blendImage: ImageObject | undefined;

    public structureSet: StructureSetObject | undefined;

    public dose: DoseDistribution | undefined;

    public registration: RigidRegistration | undefined;
}
